import { render, staticRenderFns } from "./PaymentsMapping.vue?vue&type=template&id=2bcb56cb&scoped=true&"
import script from "./PaymentsMapping.vue?vue&type=script&lang=ts&"
export * from "./PaymentsMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb56cb",
  null
  
)

export default component.exports